import React from 'react';
import { Alert, Button, Space } from 'antd';
import { useRouteError } from 'react-router-dom';

const RouteErrorFallback: React.FC = () => {
  const error: any = useRouteError();
  console.error('Route error caught:', error);

  const handleRefresh = () => {
    window.location.reload();
  };

  let errorMessage = 'Looks like something went wrong while loading this page.';
  let isChunkLoadError = false;

  if (error instanceof Error && error.name === 'ChunkLoadError') {
    errorMessage = "Не вдалось завантажити сторінку через раптове зникнення з'єднання.";
    isChunkLoadError = true;
  } else if (error && typeof error === 'object' && 'statusText' in error) {
    errorMessage = `Error: ${error.statusText || 'Unknown error'}`;
  }

  return (
    <div
      style={{
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100dvh',
        maxHeight: '100dvh',
        background: 'linear-gradient(180deg, #2a2a2a 30%, #3a3a3a 50%, #2a2a2a 100%)',
        color: '#ffffff !important'
      }}
    >
      <Alert
        message="Помилка завантаження сторінки..."
        description={
          <Space direction="vertical" style={{ color: '#ffffff' }}>
            <p>{errorMessage}</p>
            {isChunkLoadError && <p>Схоже, у вас пропав Інтернет...Оновіть сторінку ще раз</p>}
            <Button type="primary" onClick={handleRefresh} style={{ backgroundColor: '#ff8633' }}>
              Оновити
            </Button>
          </Space>
        }
        type="error"
        showIcon
        style={{
          maxWidth: '500px',
          width: '100%',
          background: '#2a2a2a'
        }}
      />
    </div>
  );
};

export default RouteErrorFallback;
